// Globals
import React, { ReactNode, useMemo } from 'react';
import debounce from 'lodash.debounce';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { getImportsList, selectImportsFilters, setImportsFilters } from '../../feature';

// Modules
import { getPartnersOptions, usePartnersListSearch } from '@/modules/Partners';

// Components
import { StyledFilterRow } from './ImportsFiltersContainerStyles';
import { StyledSelect } from '../../components/Styled';

// Helpers
import { GetImportsListDTO } from '../../dtos';

type IImportsFiltersContainer = {
  children?: ReactNode;
  className?: string;
};

const ImportsFiltersContainer = ({ children, className }: IImportsFiltersContainer) => {
  const dispatch = useAppDispatch();
  const { partnersList, searchPartners } = usePartnersListSearch();
  const query = useAppState(selectImportsFilters);

  const handleDebounceSearch = useMemo(
    () =>
      debounce(async (searchParams) => {
        const dto = new GetImportsListDTO(searchParams);
        dispatch(getImportsList(dto));
      }, 500),
    [dispatch],
  );

  const handlePartnerChange = (value: unknown) => {
    const newQuery = { ...query, partner_ids: value || undefined };
    dispatch(setImportsFilters(newQuery));
    handleDebounceSearch(newQuery);
  };

  return (
    <thead className={className}>
      {children}
      <StyledFilterRow>
        <th />
        <th />
        <th />
        <th>
          <StyledSelect
            allowClear
            showSearch
            isMultiselect
            onChange={handlePartnerChange}
            options={getPartnersOptions(partnersList ?? [])}
            onSearch={searchPartners}
          />
        </th>
        <th />
        <th />
        <th />
        <th />
      </StyledFilterRow>
    </thead>
  );
};

export default ImportsFiltersContainer;
